<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="d-flex flex-row">
      <input (change)="onFileSelected($event)" class="open-file" style="display: none;" type="file" id="openFile"
             #openFile name="openFile" accept="image/png, image/jpg, image/jpeg"/>
      <img class="edit_employee_profile_picture"
           (click)="openAddImage()"
           [src]="determineImageForEmployee(employeeModel.pictureUrl)"
           alt="profile-picture">
      <div class="picture-edit align-self-center">
        <p class="primary_medium_text_16 m-0">
          {{ 'MANAGER_EMPLOYEES.UPLOAD_IMAGE_MESSAGE' | translate }}
          <label *ngIf="pictureIsWrongFormat">
            <i class="pi pi-exclamation-circle me-1 error_color wrong_format_tooltip"
               pTooltip="{{'MANAGER_EMPLOYEES.WRONG_FORMAT' | translate}}" tooltipPosition="top"></i>
          </label>
        </p>
      </div>
    </div>
  </div>

  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="w-50">
      <label class="lbl_pos_field">{{'MANAGER_EMPLOYEES.NAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['FirstName']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['FirstName']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.firstName">
    </div>
    <div class="w-50">
      <label class="lbl_pos_field">{{'MANAGER_EMPLOYEES.SURNAME' | translate}}
        <i *ngIf="errorModel!=null && errorModel['LastName']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['LastName']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.lastName">
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="w-50">
      <label class="lbl_pos_field">{{'MANAGER_EMPLOYEES.EMAIL' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Email']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Email']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.email" disabled>
    </div>
    <div class="w-50">
      <label class="lbl_pos_field">{{'MANAGER_EMPLOYEES.PHONE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Phone']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Phone']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="number" class="primary_input_field custom_number_input" [(ngModel)]="employeeModel.phone">
    </div>
  </div>
  <div class="d-flex flex-row justify-content-between pb-2">
    <div class="w-50">
      <label class="lbl_pos_field">{{'MANAGER_EMPLOYEES.ADDRESS' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Address']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Address']|translate}}" tooltipPosition="top"></i>
      </label>
      <input type="text" class="primary_input_field" [(ngModel)]="employeeModel.address">
    </div>
    <div class="w-50">
      <label class="lbl_pos_field">{{'MANAGER_EMPLOYEES.ROLE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['Role']!=null"
           class="pi pi-exclamation-circle me-1 mt-1 error_color float-end"
           pTooltip="{{errorModel['Role']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-dropdown class="pos_dropdown" [options]="rolesDropdownHelperModels" [(ngModel)]="employeeModel.venueEmployeeTypeId" optionLabel="name"
                  optionValue="id" placeholder="{{'MANAGER_EMPLOYEES.SELECT_ROLE' | translate}}"></p-dropdown>
    </div>
  </div>
  <ng-container *ngIf="employeeModel.venueEmployeeTypeId && employeeModel.venueEmployeeTypeId === employeeRoleEnum.Waiter">
    <div class="d-flex flex-row justify-content-between pb-2 mt-2">
      <div class="w-50">
        <button (click)="generatePin()" class="p-0 btn_magenta_large w-100 mt-2" [class.btn_cyan_large]="employeeHasPIN(employeeModel.pin)">
          {{employeeHasPIN(employeeModel.pin) ? employeeModel.pin : 'MANAGER_EMPLOYEES.GENERATE_PIN' | translate}}
        </button>
      </div>
      <div class="w-50">
        <p class="primary_medium_text_14 mt-1">
          {{'MANAGER_EMPLOYEES.GENERATE_PIN_MESSAGE' | translate}}
        </p>
      </div>
    </div>
  </ng-container>
  <div class="d-flex flex-row justify-content-between pb-2">
    <button class="btn_login w-100" (click)="updateEmployee(employeeModel)"
            [disabled]="!employeeModel.venueEmployeeTypeId || (employeeModel.venueEmployeeTypeId === employeeRoleEnum.Waiter && (employeeModel.pin === '0000' || employeeModel.pin.trim() === ''))">{{ 'SAVE' | translate}}</button>
  </div>
</div>
<p-toast position="top-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
